import React from 'react';
import PropTypes from 'prop-types';
import ScriptLoader from 'react-script-loader-hoc';
import { Card, Typography, Anchor } from 'components/base';
import Icon, { ICON_TYPE } from 'components/icon';
import copyToClipboard from 'utils/copyToClipboard';

const ReferFriendShareCode = props => {
  const handleOnCopyClick = e => {
    e.preventDefault();

    copyToClipboard(props.value);
  };

  const handleOnEmailClick = e => {
    e.preventDefault();

    window.location.href = `mailto:?subject=${props.subject}&body=${props.text}${props.url}`;
  };

  return (
    <div className="share-social a2a_kit" data-a2a-url={props.url} data-a2a-title={props.text}>
      <Card>
        <Card.Body className="text-center">
          <Typography.H3 className="text-light mb-2">Share your code with friends</Typography.H3>
          <Typography.H1 className="mb-2">{props.value}</Typography.H1>
          <Anchor onClick={handleOnCopyClick}>Copy to clipboard</Anchor>
        </Card.Body>
        <Card.Footer>
          <div className="card-footer-item">
            <Anchor className="text-light a2a_button_facebook single-social facebook">
              <Icon type={ICON_TYPE.FACEBOOK} />
            </Anchor>
          </div>
          <div className="card-footer-item">
            <Anchor className="text-light a2a_button_twitter single-social twitter">
              <Icon type={ICON_TYPE.TWITTER} />
            </Anchor>
          </div>
          <div className="card-footer-item">
            <Anchor className="text-light" onClick={handleOnEmailClick}>
              <Icon type={ICON_TYPE.ENVELOPE} />
            </Anchor>
          </div>
        </Card.Footer>
      </Card>
    </div>
  );
};

ReferFriendShareCode.propTypes = {
  value: PropTypes.string,
  subject: PropTypes.string,
  text: PropTypes.string,
  url: PropTypes.string,
};

export default ScriptLoader('//static.addtoany.com/menu/page.js')(ReferFriendShareCode);
